<template>
  <div>
    <div class="col-9 ms-auto me-5 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div>
          <div class="body-title">Roles y permisos</div>
        </div>
        <div>
          <button
            id="modal-open"
            type="button"
            class="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#addRol"
            @click="focus()"
          >
            <i class="fa-solid fa-plus me-2" id="modal-open"></i>Agregar rol
          </button>
        </div>
      </div>
      <div class="content-view">
        <paginate name="elements" :list="allRoles" :per="15">
          <table class="table table-hover mt-3">
            <thead>
              <th>Id</th>
              <th>Nombre</th>
            </thead>
            <tbody class="position-relative">
              <!-- Refactorizar y cambiar rol_id -->
              <tr
                v-for="(rol, i) in paginated('elements')"
                :key="i"
                :id="`product-row-${i}`"
                @click="editRol(rol), (rol_id = rol.id)"
                @mouseenter="addOrRemoveDeleteOptClass($event)"
                @mouseleave="addOrRemoveDeleteOptClass($event)"
              >
                <td>{{ rol.id }}</td>
                <td>{{ rol.name }}</td>
                <td class="deleteOpt text-danger" @click.stop="confirmDeleteRol(rol.id)">
                  <i class="bi bi-trash-fill"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </paginate>

        <paginate-links
          for="elements"
          :limit="9"
          :hide-single-page="true"
          :show-step-links="true"
          :step-links="{
            next: '  ❯',
            prev: '❮  ',
          }"
        ></paginate-links>
      </div>

      <!-- Modals -->
      <!-- Add or Edit Product -->
      <div
        class="modal fade"
        id="addRol"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <!-- Refactorizar para que solo cambie el h5 -->
              <section v-if="rol_id">
                <h5 class="modal-title fw-bold">Editar rol</h5>
              </section>
              <section v-else>
                <h5 class="modal-title fw-bold">Agregar rol</h5>
              </section>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <form @submit.prevent="rol_id ? updateRolPermissions() : addRolAndPermissions()" @keydown.enter.prevent>
                <div class="d-flex justify-content-between col-12 my-2">
                  <div class="col-5 form-group">
                    <label for="">Rol:</label>
                    <input
                      id="name"
                      @keydown.enter="enterAsTab"
                      type="text"
                      name="name"
                      class="form-control"
                      v-model="rol.name"
                      required
                    />
                  </div>
                </div>

                <div class="col-12 border rounded py-2">
                  <div class="row fw-bold border-bottom mb-2 py-2">
                    <div class="col">Formulario</div>
                    <div class="col text-center">Ver</div>
                    <div class="col text-center">Editar</div>
                    <div class="col text-center">Guardar</div>
                    <div class="col text-center">Eliminar</div>
                  </div>

                  <div class="row" v-for="(model, modelName) in models" :key="modelName">
                    <div class="col fw-bold">{{ modelName }}</div>
                    <div class="col col d-flex justify-content-center">
                      <div class="form-check form-switch col-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="isChecked(modelName, 'get')"
                          @click="editPermissions(`${modelName}.get`)"
                        />
                      </div>
                    </div>

                    <div class="col d-flex justify-content-center">
                      <div class="form-check form-switch col-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="isChecked(modelName, 'put')"
                          @click="editPermissions(`${modelName}.put`)"
                        />
                      </div>
                    </div>

                    <div class="col d-flex justify-content-center">
                      <div class="form-check form-switch col-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="isChecked(modelName, 'post')"
                          @click="editPermissions(`${modelName}.post`)"
                        />
                      </div>
                    </div>

                    <div class="col d-flex justify-content-center">
                      <div class="form-check form-switch col-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="isChecked(modelName, 'delete')"
                          @click="editPermissions(`${modelName}.delete`)"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-footer border-0">
                  <!-- Refactorizar solo el texto del boton dependiendo del valor de la variable -->
                  <section v-if="rol_id">
                    <button type="submit" class="btn btn-success" aria-label="Close">Actualizar rol</button>
                  </section>
                  <section v-else>
                    <button
                      type="submit"
                      class="btn btn-success"
                      aria-label="Close"
                      :disabled="!permissionsToAdd.length"
                    >
                      Añadir rol
                    </button>
                  </section>
                  <button
                    id="modal-close"
                    type="button"
                    class="btn btn-danger"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePaginate from "vue-paginate";
import CurrencyInput from "../CurrencyInputComponent.vue";

export default {
  data() {
    return {
      rol_id: 0,
      permissions: [],
      allRoles: [],
      wHeight: window.innerHeight - 125,
      rol: {
        name: "",
      },
      permissionsToAdd: [],
      permissionsToDelete: [],
      rolPermissions: [],
      models: [],

      paginate: ["elements"],
    };
  },
  components: {
    VuePaginate,
    CurrencyInput,
  },
  methods: {
    getPermissions() {
      axios.get("/permission/get-all-permissions").then((response) => {
        this.permissions = response.data.permissions;
      });
    },
    // Get all roles with their permissions
    getRoles() {
      axios.get("/permission/get-all-roles").then((response) => {
        this.allRoles = response.data.roles;
      });
    },
    /** Comentar */
    isChecked(modelName, method) {
      let permission = `${modelName}.${method}`;
      if (!this.rol_id) {
        return false;
      } else {
        return this.rolPermissions.filter((p) => p.name == permission).length; // Number mayor then 0
      }
    },
    // Add Or Remove permissions to rol
    editPermissions(permission) {
      let permissionSplit = permission.split(".");
      let exist = this.isChecked(permissionSplit[0], permissionSplit[1]); // Know if Rol has permision or not
      let indexAdd = this.permissionsToAdd.indexOf(permission); // Know if array has permission added

      if (exist) {
        // Rol has the permission
        let permissionSelected = this.rolPermissions.filter((rp) => rp.name == permission);
        let indexDelete = this.permissionsToDelete.indexOf(permissionSelected[0].permission_id);

        if (indexDelete > -1) {
          // Add Array has the permission added
          this.permissionsToDelete.splice(indexDelete, 1);
        } else {
          // Array doesn't have the permission added
          this.permissionsToDelete.push(permissionSelected[0].permission_id);
        }
      } else {
        if (indexAdd > -1) {
          this.permissionsToAdd.splice(indexAdd, 1);
        } else {
          this.permissionsToAdd.push(permission);
        }
      }
    },
    // Create a new rol with their permission
    addRolAndPermissions() {
      axios
        .post("/permission", {
          name: this.rol.name,
          permissions: this.permissionsToAdd,
        })
        .then((response) => {
          if (response.data.success) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });
            this.getRoles();
            document.getElementById("modal-close").click();
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: response.data.error,
            });
          }
        });
    },
    /**  Refactorizar */
    editRol(rol) {
      axios.get("permission/role-permissions/" + rol.id).then((response) => {
        /* Manejar respuesta */
        this.rolPermissions = response.data.role;
        this.rol.name = rol.name;
      });

      (this.permissionsToAdd = []), (this.permissionsToDelete = []), document.getElementById("modal-open").click();
    },
    // Update the rol permissions
    updateRolPermissions() {
      axios
        .post(`/permission/rol-update/${this.rol_id}`, {
          rol: this.rol,
          role_id: this.rol_id,
          add_ids: this.permissionsToAdd,
          delete_ids: this.permissionsToDelete,
        })
        .then((response) => {
          if (response.data.success) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });

            this.getRoles();
            this.clearRolePermission();
            document.getElementById("modal-close").click();
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: response.data.error,
            });
          }
        });
    },

    // Get all models with their permissions
    getModelNames() {
      axios.get(`/permission/model-names`).then((response) => {
        this.models = response.data.models;
      });
    },

    // Confirm message before add or update any rol
    confirmDeleteRol(id) {
      Swal.fire({
        title: `¿Deseas eliminar este rol?`,
        showDenyButton: true,
        confirmButtonText: "Sí",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteRol(id);
        }
      });
    },
    // Delete rol
    deleteRol(id) {
      axios.delete(`/permission/${id}`).then((response) => {
        if (response.data.errors) {
          Swal.fire({
            icon: "error",
            title: "Existen usuarios utilizando este rol",
            text: response.data.errors,
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: response.data.success,
          });
          this.getRoles();
        }
      });
    },

    clearRolePermission() {
      this.rol_id = 0;
      this.rolPermissions = [];
      this.rol = {
        name: "",
      };
    },

    focus() {
      setTimeout(() => {
        document.getElementById("name").focus();
      }, "500");
    },
  },
  computed: {},
  created() {
    this.getPermissions();
    this.getRoles();
    this.getModelNames();
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  label {
    color: var(--first-color-dark);
  }
}

.invoice-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.body-title {
  font-weight: 900;
  font-size: var(--font-normal-title);
}

/* Table styles */
table {
  th {
    color: var(--first-color-dark);
  }

  td {
    padding: 0;
  }
  .selected {
    background: #c3c2c2;
  }

  .table-footer {
    border: white;
  }
}
.table-body {
  overflow: auto;
  height: 288px;
}
.modal-body {
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(57, 48, 48);
    border-radius: 10px;
  }
}

.paragraph {
  color: var(--first-color-dark);
}
.label-form {
  color: var(--first-color-dark);
}

div.swal2-actions {
  width: 50% !important;
  justify-content: space-around !important;
}

.form-check-input:checked {
  background-color: #198754;
  border-color: #198754;
}
.form-check-input {
  background-color: #dc3545;
  border-color: #dc3545;
}
</style>
